<template>
  <div>
    <div v-if="isStudyLoadedSuccessfully">
      <router-view/>
    </div>
    <div v-else>
      <div class="spaced">
        <div v-if="isStudyLoading">
          <div class="centered-row">
            <Loading></Loading>
          </div>
        </div>
        <div v-if="didStudyFailToLoad">
          <div class="centered-row">
            <span>Study failed to load</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    LOADING_COMPLETED_FAILURE,
  } from '../../services/constants'

  export default {
    name: 'StudyContainer',
    computed: {
      getStudyState() {
        return this.$store.state.dataModule.getStudyState
      },
      isStudyLoading() {
        return this.getStudyState.loadingState === LOADING_STARTED
      },
      isStudyLoadedSuccessfully() {
        return this.getStudyState.loadingState === LOADING_COMPLETED_SUCCESS
      },
      didStudyFailToLoad() {
        return this.getStudyState.loadingState === LOADING_COMPLETED_FAILURE
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .spaced {
    padding: 1em;
  }

  .text-1 {
    color: $red-2;
  }
</style>
